exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /ng-app/src/app/announcements/announcement-view/announcement-view.component.css
// module id = ../../../../../src/app/announcements/announcement-view/announcement-view.component.css
// module chunks = main